/**
 * Ask Clara configuration (self-contained — delete this folder to remove the feature).
 * To disable without deleting anything, set ENABLED to false.
 */

// Agent service base URL.
// - Running the app locally (localhost) → talk to the locally-run agent_manager on :5099.
//   This avoids cross-origin CORS + cookie issues (the deployed backend doesn't allow the
//   localhost origin, and the app's session cookie won't cross origins).
// - Otherwise (deployed) → same-origin under the app host (from API_BASE_URL) so the session
//   cookie flows for per-user RBAC.
const isLocalhost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
const AGENT_BASE_URL = isLocalhost
  ? 'http://localhost:5099'
  : `${process.env.API_BASE_URL || ''}agent-manager`;

// eslint-disable-next-line import/prefer-default-export
export const COPILOT_CONFIG = {
  ENABLED: true,
  AGENT_BASE_URL,
  AGENT_ID: 'copilot',

  /**
   * Roles that can see/use Ask Clara. To grant more roles, add them here (e.g.
   * ['admin', 'marcom', 'project_owner']) AND set the backend env COPILOT_ALLOWED_ROLES to the
   * SAME list — the backend is the real security gate; this only controls who sees the launcher.
   * Use the exact role strings the app stores on the user (e.g. 'admin', 'marcom', 'brand_owner').
   */
  ALLOWED_ROLES: ['admin'],

  /**
   * Per-user auth. Deployed same-origin under the app domain: leave blank — `withCredentials`
   * sends the logged-in user's `access_token` cookie automatically for real per-user RBAC.
   * (Local-only fallback: paste a dev access token here to test cross-origin against localhost.)
   */
  AGENT_BEARER_TOKEN: '',
};
